<section class="fornecedor-shell">
  <header class="fornecedor-hero">
    <div>
      <h2 class="fornecedor-title">{{ isEditMode ? 'Editar Fornecedor' : 'Novo Fornecedor' }}</h2>
      <p class="fornecedor-subtitle">Preencha os dados cadastrais do fornecedor.</p>
    </div>
    <span class="fornecedor-chip">{{ isEditMode ? 'Edição' : 'Cadastro' }}</span>
  </header>

  <form [formGroup]="fornecedorForm" (ngSubmit)="salvarFornecedor()" id="fornecedorForm" class="fornecedor-card">
    <div class="form-section">
      <h3>Dados Cadastrais</h3>
      <div class="row g-3">
        <div class="col-md-6">
          <label for="razaoSocial" class="form-label">Razão Social</label>
          <input type="text" id="razaoSocial" formControlName="razaoSocial" class="form-control"
            [ngClass]="{ 'is-invalid': fornecedorForm.get('razaoSocial')?.invalid && fornecedorForm.get('razaoSocial')?.touched }">
          <div *ngIf="fornecedorForm.get('razaoSocial')?.invalid && fornecedorForm.get('razaoSocial')?.touched" class="invalid-feedback">
            Razão Social é obrigatória.
          </div>
        </div>
        <div class="col-md-6">
          <label for="nomeFantasia" class="form-label">Nome Fantasia</label>
          <input type="text" id="nomeFantasia" formControlName="nomeFantasia" class="form-control"
            [ngClass]="{ 'is-invalid': fornecedorForm.get('nomeFantasia')?.invalid && fornecedorForm.get('nomeFantasia')?.touched }">
          <div *ngIf="fornecedorForm.get('nomeFantasia')?.invalid && fornecedorForm.get('nomeFantasia')?.touched" class="invalid-feedback">
            Nome Fantasia é obrigatório.
          </div>
        </div>
        <div class="col-md-6">
          <label for="cnpj" class="form-label">CNPJ</label>
          <input type="text" id="cnpj" formControlName="cnpj" class="form-control" mask="00.000.000/0000-00"
            [ngClass]="{ 'is-invalid': fornecedorForm.get('cnpj')?.invalid && fornecedorForm.get('cnpj')?.touched }">
          <div *ngIf="fornecedorForm.get('cnpj')?.invalid && fornecedorForm.get('cnpj')?.touched" class="invalid-feedback">
            CNPJ é obrigatório.
          </div>
        </div>
        <div class="col-md-6">
          <label for="inscricaoEstadual" class="form-label">Inscrição Estadual</label>
          <input type="text" id="inscricaoEstadual" formControlName="inscricaoEstadual" class="form-control">
        </div>
        <div class="col-md-6">
          <label for="inscricaoMunicipal" class="form-label">Inscrição Municipal</label>
          <input type="text" id="inscricaoMunicipal" formControlName="inscricaoMunicipal" class="form-control">
        </div>
        <div class="col-md-6">
          <label for="email" class="form-label">Email</label>
          <input type="email" id="email" formControlName="email" class="form-control"
            [ngClass]="{ 'is-invalid': fornecedorForm.get('email')?.invalid && fornecedorForm.get('email')?.touched }">
          <div *ngIf="fornecedorForm.get('email')?.touched && fornecedorForm.get('email')?.errors?.['required']" class="invalid-feedback">
            Email é obrigatório.
          </div>
          <div *ngIf="fornecedorForm.get('email')?.touched && fornecedorForm.get('email')?.errors?.['email']" class="invalid-feedback">
            Formato de email inválido.
          </div>
        </div>
        <div class="col-md-6">
          <label for="site" class="form-label">Site</label>
          <input type="text" id="site" formControlName="site" class="form-control">
        </div>
      </div>
    </div>

    <div class="form-section">
      <h3>Endereço e Contato</h3>
      <div class="row g-3">
        <div class="col-md-6">
          <label for="endereco" class="form-label">Endereço</label>
          <input type="text" id="endereco" formControlName="endereco" class="form-control"
            [ngClass]="{ 'is-invalid': fornecedorForm.get('endereco')?.invalid && fornecedorForm.get('endereco')?.touched }">
          <div *ngIf="fornecedorForm.get('endereco')?.invalid && fornecedorForm.get('endereco')?.touched" class="invalid-feedback">
            Endereço é obrigatório.
          </div>
        </div>
        <div class="col-md-6">
          <label for="numeroPredial" class="form-label">Número</label>
          <input type="text" id="numeroPredial" formControlName="numeroPredial" class="form-control"
            [ngClass]="{ 'is-invalid': fornecedorForm.get('numeroPredial')?.invalid && fornecedorForm.get('numeroPredial')?.touched }">
          <div *ngIf="fornecedorForm.get('numeroPredial')?.invalid && fornecedorForm.get('numeroPredial')?.touched" class="invalid-feedback">
            Número é obrigatório.
          </div>
        </div>
        <div class="col-md-6">
          <label for="cep" class="form-label">CEP</label>
          <input type="text" id="cep" formControlName="cep" class="form-control" mask="00.000-000"
            [ngClass]="{ 'is-invalid': fornecedorForm.get('cep')?.invalid && fornecedorForm.get('cep')?.touched }">
          <div *ngIf="fornecedorForm.get('cep')?.invalid && fornecedorForm.get('cep')?.touched" class="invalid-feedback">
            CEP é obrigatório.
          </div>
        </div>
        <div class="col-md-6">
          <label for="cidade" class="form-label">Cidade</label>
          <input type="text" id="cidade" formControlName="cidade" class="form-control"
            [ngClass]="{ 'is-invalid': fornecedorForm.get('cidade')?.invalid && fornecedorForm.get('cidade')?.touched }">
          <div *ngIf="fornecedorForm.get('cidade')?.invalid && fornecedorForm.get('cidade')?.touched" class="invalid-feedback">
            Cidade é obrigatória.
          </div>
        </div>
        <div class="col-md-6">
          <label for="estado" class="form-label">Estado</label>
          <select id="estado" formControlName="estado" class="form-control"
            [ngClass]="{ 'is-invalid': fornecedorForm.get('estado')?.invalid && fornecedorForm.get('estado')?.touched }">
            <option value="">Selecione a UF</option>
            <option *ngFor="let uf of ufs" [value]="uf">{{ uf }}</option>
          </select>
          <div *ngIf="fornecedorForm.get('estado')?.invalid && fornecedorForm.get('estado')?.touched" class="invalid-feedback">
            Selecione uma UF válida.
          </div>
        </div>
        <div class="col-md-6">
          <label for="telefone" class="form-label">Telefone</label>
          <input type="text" id="telefone" formControlName="telefone" class="form-control"
            [ngClass]="{ 'is-invalid': fornecedorForm.get('telefone')?.invalid && fornecedorForm.get('telefone')?.touched }">
          <div *ngIf="fornecedorForm.get('telefone')?.invalid && fornecedorForm.get('telefone')?.touched" class="invalid-feedback">
            Telefone é obrigatório.
          </div>
        </div>
        <div class="col-md-12">
          <label for="observacoes" class="form-label">Observações</label>
          <textarea id="observacoes" formControlName="observacoes" class="form-control" rows="3"></textarea>
        </div>
      </div>
    </div>
  </form>

  <footer class="action-bar">
    <button type="button" class="btn btn-outline-secondary" (click)="cancelar()">Cancelar</button>
    <button type="submit" form="fornecedorForm" class="btn btn-primary" [disabled]="fornecedorForm.invalid">Salvar</button>
  </footer>
</section>
